<script setup>
import { computed, ref } from "vue";
import InfiniteArticleList from "./components/ArticleList/InfiniteArticleList.vue";
import { useResultsStore } from "./stores/results";

const resultsStore = useResultsStore();

const isReloading = ref(true);

const props = defineProps({
  year: {
    type: String,
    required: true,
  },
  month: {
    type: String,
    required: false,
  },
});

const filters = computed(() => {
  const monthFrom = props.month ? props.month : "01";
  const monthTo = props.month ? props.month : "12";

  return {
    dateFrom: `${props.year}-${monthFrom}-01`,
    dateTo: `${props.year}-${monthTo}-31`,
  };
});

async function init() {
  await resultsStore.fetchResults(filters.value);
  isReloading.value = false;
}

init();
</script>

<template>
  <InfiniteArticleList class="container" :filters="filters" :is-reloading="isReloading" />
</template>

